import clsx from 'clsx'
import { Col, Form, Input, Password, Row, Space, Text } from 'components/common'

export interface NameAndEmailFormProps {
  defaultValues?: {
    corporationName?: string
    corporationNameKana?: string
    firstName?: string
    lastName?: string
    password?: string
    email?: string
    phone?: string
  }
  type: 'personal' | 'corporate' | 'unregistered'
  isNew?: boolean
}
const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const NameAndEmailForm = ({
  type,
  defaultValues = {},
  isNew,
}: NameAndEmailFormProps): JSX.Element => {
  const {
    corporationName,
    corporationNameKana,
    firstName,
    lastName,
    email,
    password,
    phone,
  } = defaultValues
  return (
    <>
      {type === 'corporate' && (
        <>
          <Form.Item
            name="corporationName"
            label="法人・団体名"
            labelCol={{ span: 24 }}
            initialValue={corporationName}
            rules={[
              { required: true },
              {
                type: 'string',
                min: 1,
                max: 265,
              },
            ]}
          >
            <Input autoComplete="off" />
          </Form.Item>

          <Form.Item
            name="corporationNameKana"
            label="法人・団体名（フリガナ）"
            labelCol={{ span: 24 }}
            initialValue={corporationNameKana}
            rules={[
              {
                required: true,
              },
              {
                type: 'string',
                min: 1,
                max: 265,
              },
            ]}
          >
            <Input autoComplete="off" />
          </Form.Item>
          <Col span={24} className={clsx('pb-3')}>
            <Text>担当者</Text>
          </Col>
        </>
      )}
      <Row>
        <Space>
          <Form.Item
            name="lastName"
            label="姓"
            labelCol={{ span: 24 }}
            initialValue={lastName}
            rules={[
              {
                required: true,
              },
              {
                type: 'string',
                min: 1,
                max: 64,
              },
            ]}
          >
            <Input autoComplete="off" />
          </Form.Item>
          <Form.Item
            name="firstName"
            label="名"
            labelCol={{ span: 24 }}
            initialValue={firstName}
            rules={[
              { required: true },
              {
                type: 'string',
                min: 1,
                max: 64,
              },
            ]}
          >
            <Input autoComplete="off" />
          </Form.Item>
        </Space>
      </Row>

      <Form.Item
        name="email"
        label="メールアドレス"
        labelCol={{ span: 24 }}
        initialValue={email}
        rules={[
          {
            required: true,
            message: 'メールアドレスは必須です。',
          },
          {
            type: 'string',
          },
          {
            pattern: EMAIL_REGEX,
            message: 'メールアドレスが無効です。',
          },
        ]}
      >
        <Input autoComplete="off" type="email" />
      </Form.Item>
      {isNew && (
        <Form.Item
          name="password"
          label="パスワード"
          labelCol={{ span: 24 }}
          initialValue={password}
          rules={[
            {
              required: true,
              message: 'パスワードは必須です。',
            },
            {
              type: 'string',
            },
          ]}
        >
          <Password autoComplete="off" />
        </Form.Item>
      )}

      <Form.Item
        name="phone"
        label="電話番号"
        labelCol={{ span: 24 }}
        initialValue={phone}
        rules={[
          {
            pattern: /^\d{6,11}$/,
            message: '電話番号は6〜11桁の数字を入力してください。',
          },
        ]}
      >
        <Input autoComplete="off" />
      </Form.Item>
    </>
  )
}
